var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("div", { staticClass: "mb-2" }, [
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v(
                _vm._s(
                  _vm.isEditMode
                    ? _vm.model.name || _vm.$t("subscription_plan.title")
                    : _vm.$t("catalog.plan.new_title")
                )
              ),
            ]),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.$t("catalog.plan.subtitle"))),
            ]),
          ]),
          _c(
            "wizard-shell",
            {
              attrs: {
                steps: _vm.steps,
                current: _vm.currentStep,
                "done-keys": _vm.doneKeys,
                "free-navigation": _vm.isEditMode,
                "next-disabled": _vm.nextDisabled,
                busy: _vm.busy,
              },
              on: { prev: _vm.goPrev, next: _vm.goNext, goto: _vm.goToStep },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "sobre",
                      expression: "currentStep === 'sobre'",
                    },
                  ],
                },
                [
                  _c("validation-observer", {
                    ref: "aboutValidator",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var valid = ref.valid
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-7/12 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "subscription_plan.name"
                                          ),
                                          rules: "required",
                                          mode: "lazy",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (validationContext) {
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "subscription_plan.name"
                                                        ),
                                                        "label-for": "name",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass: "required",
                                                        attrs: {
                                                          id: "name",
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "catalog.plan.name_placeholder"
                                                          ),
                                                          state:
                                                            _vm.getValidationState(
                                                              validationContext
                                                            ),
                                                        },
                                                        model: {
                                                          value: _vm.model.name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.name",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-form-invalid-feedback",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              validationContext
                                                                .errors[0]
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-5/12 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("responsible_entity"),
                                          rules: "required",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (validationContext) {
                                                return [
                                                  _c("select-suggestion", {
                                                    attrs: {
                                                      id: "legal_entity_id",
                                                      column:
                                                        "company_name,trading_name,cnpj",
                                                      model: "LegalEntity",
                                                      label:
                                                        _vm.$t(
                                                          "responsible_entity"
                                                        ),
                                                      appendClearOption: false,
                                                      placeholderText:
                                                        _vm.pessoaJuridicaLocked
                                                          ? ""
                                                          : "Digite o nome do estabelecimento",
                                                      itemTextFormat:
                                                        _vm.legalEntityItemTextFormat,
                                                      isDisabled:
                                                        _vm.pessoaJuridicaLocked,
                                                      required: true,
                                                    },
                                                    model: {
                                                      value: _vm.legalEntity,
                                                      callback: function ($$v) {
                                                        _vm.legalEntity = $$v
                                                      },
                                                      expression: "legalEntity",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          validationContext
                                                            .errors[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t(
                                      "subscription_plan.description"
                                    ),
                                    rules: "max:500",
                                    slim: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (validationContext) {
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "mt-1",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "subscription_plan.description"
                                                  ),
                                                  "label-for": "description",
                                                },
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    id: "description",
                                                    rows: "3",
                                                    "max-rows": "6",
                                                    state:
                                                      _vm.getValidationState(
                                                        validationContext
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "catalog.plan.description_hint"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c("b-form-invalid-feedback", [
                                                  _vm._v(
                                                    _vm._s(
                                                      validationContext
                                                        .errors[0]
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c(
                                  "b-alert",
                                  {
                                    staticClass: "p-1 mt-1 mb-0",
                                    attrs: {
                                      show: _vm.model.status === "IN",
                                      variant: "warning",
                                    },
                                  },
                                  [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("catalog.plan.inactive_legacy")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                !valid
                                  ? _c("div", { staticClass: "mt-1" }, [
                                      _c(
                                        "small",
                                        { staticClass: "text-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "catalog.wizard.fill_required"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "regras",
                      expression: "currentStep === 'regras'",
                    },
                  ],
                },
                [
                  _c("validation-observer", {
                    ref: "rulesValidator",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var valid = ref.valid
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c("h6", { staticClass: "mb-50" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "subscription_plan.section_billing"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "subscription-plan-interval-billing-row",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "subscription-plan-interval-block",
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "subscription_plan.interval"
                                            ),
                                            rules: "required",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "subscription_plan.interval"
                                                          ),
                                                          "label-for":
                                                            "interval",
                                                          "label-class":
                                                            "required",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-form-radio-group",
                                                          {
                                                            attrs: {
                                                              id: "interval",
                                                              options:
                                                                _vm.intervalOptions,
                                                              stacked: "",
                                                              "value-field":
                                                                "value",
                                                              "text-field":
                                                                "label",
                                                              state:
                                                                _vm.getValidationState(
                                                                  validationContext
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.model
                                                                  .interval,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.model,
                                                                    "interval",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "model.interval",
                                                            },
                                                          }
                                                        ),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger d-block",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "subscription-plan-billing-block",
                                      },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "flex-grow mb-0",
                                            attrs: {
                                              label: _vm.$t(
                                                "subscription_plan.billing_cycles"
                                              ),
                                              "label-for": "billing_cycles",
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-muted d-block mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "subscription_plan.billing_cycles_help"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "billing_cycles",
                                                type: "number",
                                                min: "1",
                                                step: "1",
                                                placeholder: _vm.$t(
                                                  "subscription_plan.billing_unlimited"
                                                ),
                                              },
                                              model: {
                                                value: _vm.model.billing_cycles,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "billing_cycles",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "model.billing_cycles",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("hr", { staticClass: "my-2" }),
                                _c("h6", { staticClass: "mb-50" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "subscription_plan.section_entitlement"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "subscription_plan.commitment_type"
                                      ),
                                    },
                                  },
                                  [
                                    _c("choice-cards", {
                                      attrs: {
                                        options: _vm.commitmentCards,
                                        value: _vm.model.commitment_type,
                                        disabled: _vm.lockedFieldsFrozen,
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.model.commitment_type = $event
                                        },
                                      },
                                    }),
                                    _vm.lockedFieldsFrozen
                                      ? _c(
                                          "small",
                                          {
                                            staticClass:
                                              "text-muted d-block mt-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "subscription_plan.locked_by_subscribers"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm.hasQuota
                                  ? _c("div", { staticClass: "vx-row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vx-col sm:w-5/12 w-full",
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "subscription_plan.classes_per_period"
                                              ),
                                              rules:
                                                "required|integer|min_value:1",
                                              slim: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (
                                                    validationContext
                                                  ) {
                                                    return [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "subscription_plan.classes_per_period"
                                                            ),
                                                            "label-for":
                                                              "classes_per_period",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted d-block mb-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "subscription_plan.classes_per_period_help"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("b-form-input", {
                                                            staticClass:
                                                              "required",
                                                            attrs: {
                                                              id: "classes_per_period",
                                                              type: "number",
                                                              min: "1",
                                                              step: "1",
                                                              disabled:
                                                                _vm.lockedFieldsFrozen,
                                                              state:
                                                                _vm.getValidationState(
                                                                  validationContext
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.model
                                                                  .classes_per_period,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.model,
                                                                    "classes_per_period",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                              expression:
                                                                "model.classes_per_period",
                                                            },
                                                          }),
                                                          _c(
                                                            "b-form-invalid-feedback",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  validationContext
                                                                    .errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vx-col sm:w-7/12 w-full",
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "subscription_plan.quota_period"
                                              ),
                                              rules: "required",
                                              immediate: true,
                                              slim: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (
                                                    validationContext
                                                  ) {
                                                    return [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "subscription_plan.quota_period"
                                                            ),
                                                            "label-for":
                                                              "quota_period",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-radio-group",
                                                            {
                                                              attrs: {
                                                                id: "quota_period",
                                                                options:
                                                                  _vm.quotaPeriodOptions,
                                                                "value-field":
                                                                  "value",
                                                                "text-field":
                                                                  "label",
                                                                disabled:
                                                                  _vm.lockedFieldsFrozen,
                                                                state:
                                                                  _vm.getValidationState(
                                                                    validationContext
                                                                  ),
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model
                                                                    .quota_period,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model,
                                                                      "quota_period",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model.quota_period",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "b-form-invalid-feedback",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  validationContext
                                                                    .errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.entitlementSummary
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "border rounded p-1 mb-2",
                                      },
                                      [
                                        _c(
                                          "small",
                                          { staticClass: "text-muted d-block" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "subscription_plan.entitlement_preview"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "font-medium" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.entitlementSummary)
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-6/12 w-full" },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "subscription_plan.booking_horizon_days"
                                            ),
                                            "label-for": "booking_horizon_days",
                                          },
                                        },
                                        [
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-muted d-block mb-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "subscription_plan.booking_horizon_days_help"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "b-input-group",
                                            {
                                              staticStyle: {
                                                "max-width": "10rem",
                                              },
                                              attrs: { append: "dias" },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "booking_horizon_days",
                                                  type: "number",
                                                  min: "7",
                                                  max: "365",
                                                  step: "1",
                                                },
                                                model: {
                                                  value:
                                                    _vm.model
                                                      .booking_horizon_days,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "booking_horizon_days",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "model.booking_horizon_days",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-6/12 w-full" },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "subscription_plan.cancel_at_period_end"
                                            ),
                                            "label-for": "cancel_at_period_end",
                                          },
                                        },
                                        [
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-muted d-block mb-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "subscription_plan.cancel_at_period_end_help"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("b-form-checkbox", {
                                            attrs: {
                                              id: "cancel_at_period_end",
                                              switch: "",
                                            },
                                            model: {
                                              value:
                                                _vm.model.cancel_at_period_end,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "cancel_at_period_end",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.cancel_at_period_end",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("hr", { staticClass: "my-2" }),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "subscription_plan.allow_makeup"
                                      ),
                                      "label-for": "allow_makeup",
                                    },
                                  },
                                  [
                                    _c(
                                      "small",
                                      {
                                        staticClass: "text-muted d-block mb-2",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "subscription_plan.allow_makeup_help"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("b-form-checkbox", {
                                      attrs: { id: "allow_makeup", switch: "" },
                                      model: {
                                        value: _vm.model.allow_makeup,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "allow_makeup",
                                            $$v
                                          )
                                        },
                                        expression: "model.allow_makeup",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.model.allow_makeup
                                  ? _c("div", { staticClass: "vx-row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vx-col sm:w-6/12 w-full",
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "subscription_plan.makeup_expires_in_days"
                                                ),
                                                "label-for":
                                                  "makeup_expires_in_days",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  staticStyle: {
                                                    "max-width": "10rem",
                                                  },
                                                  attrs: { append: "dias" },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "makeup_expires_in_days",
                                                      type: "number",
                                                      min: "1",
                                                      step: "1",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model
                                                          .makeup_expires_in_days,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "makeup_expires_in_days",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "model.makeup_expires_in_days",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vx-col sm:w-6/12 w-full",
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "subscription_plan.min_cancel_advance_hours"
                                                ),
                                                "label-for":
                                                  "min_cancel_advance_hours",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  staticStyle: {
                                                    "max-width": "10rem",
                                                  },
                                                  attrs: { append: "horas" },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "min_cancel_advance_hours",
                                                      type: "number",
                                                      min: "0",
                                                      step: "1",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model
                                                          .min_cancel_advance_hours,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "min_cancel_advance_hours",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "model.min_cancel_advance_hours",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !valid
                                  ? _c("div", { staticClass: "mt-1" }, [
                                      _c(
                                        "small",
                                        { staticClass: "text-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "catalog.wizard.fill_required"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "aulas",
                      expression: "currentStep === 'aulas'",
                    },
                  ],
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("subscription_plan.eligibility_scope"),
                      },
                    },
                    [
                      _c("small", { staticClass: "text-muted d-block mb-1" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("subscription_plan.eligibility_scope_help")
                          )
                        ),
                      ]),
                      _c("b-form-radio-group", {
                        attrs: {
                          id: "eligibility_scope",
                          options: _vm.eligibilityScopeOptions,
                          stacked: "",
                          "value-field": "value",
                          "text-field": "label",
                          disabled: _vm.lockedFieldsFrozen,
                        },
                        model: {
                          value: _vm.model.eligibility_scope,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "eligibility_scope", $$v)
                          },
                          expression: "model.eligibility_scope",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: {
                        show: _vm.needsList && _vm.eligibilityCount === 0,
                        variant: "warning",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.$t("catalog.plan.eligibility_pending"))
                        ),
                      ]),
                    ]
                  ),
                  _vm.planId && _vm.needsList
                    ? _c("subscription-plan-eligibility", {
                        key: "eligibility-" + _vm.model.eligibility_scope,
                        attrs: {
                          id: _vm.planId,
                          scope: _vm.model.eligibility_scope,
                        },
                        on: { changed: _vm.refreshEligibilityCount },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "venda",
                      expression: "currentStep === 'venda'",
                    },
                  ],
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: {
                        show: _vm.productLoadFailed,
                        variant: "warning",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("catalog.sale.sale_unavailable"))),
                      ]),
                    ]
                  ),
                  _vm.productExists
                    ? _c("sale-step", {
                        attrs: {
                          "product-id": _vm.product.id,
                          price: _vm.product.price,
                          description: _vm.product.description,
                          "how-works": _vm.product.how_works,
                          guidelines: _vm.product.guidelines,
                          files: _vm.productFiles,
                          "subscription-plan": _vm.salePlanInfo,
                          "register-on-gateway": _vm.productRegisterOnGateway,
                          "gateway-registered": _vm.productGatewayRegistered,
                          "multi-sale": _vm.productMultiSale,
                        },
                        on: {
                          "update:price": function ($event) {
                            return _vm.$set(_vm.product, "price", $event)
                          },
                          "update:description": function ($event) {
                            return _vm.$set(_vm.product, "description", $event)
                          },
                          "update:howWorks": function ($event) {
                            return _vm.$set(_vm.product, "how_works", $event)
                          },
                          "update:how-works": function ($event) {
                            return _vm.$set(_vm.product, "how_works", $event)
                          },
                          "update:guidelines": function ($event) {
                            return _vm.$set(_vm.product, "guidelines", $event)
                          },
                          "file-uploaded": _vm.onProductFileUploaded,
                          "delete-file": _vm.deleteProductFile,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "revisar",
                      expression: "currentStep === 'revisar'",
                    },
                  ],
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: {
                        show: _vm.model.status === "IN",
                        variant: "warning",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("catalog.plan.inactive_legacy"))),
                      ]),
                    ]
                  ),
                  _c("review-step", {
                    attrs: {
                      summary: _vm.reviewSummary,
                      price: _vm.product.price,
                      "price-suffix": _vm.priceSuffix,
                      published: _vm.productPublished,
                      blockers: _vm.publishBlockers,
                      "front-url": _vm.publishedFrontUrl,
                      busy: _vm.busy,
                      "price-step-key": "venda",
                    },
                    on: {
                      goto: _vm.goToStep,
                      publish: _vm.publish,
                      "save-draft": _vm.saveDraft,
                      unpublish: _vm.unpublish,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.planId
        ? _c(
            "vx-card",
            {
              staticClass: "mb-4",
              attrs: { title: _vm.$t("subscription_plan.section_subscribers") },
            },
            [
              _c("subscription-plan-subscribers", {
                attrs: { id: _vm.planId },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }